module.exports = __webpack_public_path__ + "img/登录验证2.061cbea8.jpg";